import { render, staticRenderFns } from "./vehicle-options-black.vue?vue&type=template&id=65b72a84&scoped=true&"
import script from "./vehicle-options-black.vue?vue&type=script&lang=js&"
export * from "./vehicle-options-black.vue?vue&type=script&lang=js&"
import style0 from "../../static/bootstrap-3.3.7-dist/css/bootstrap.min.css?vue&type=style&index=0&id=65b72a84&scoped=true&lang=css&"
import style1 from "./vehicle-options-black.vue?vue&type=style&index=1&id=65b72a84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65b72a84",
  null
  
)

export default component.exports